/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Api_Keys_Edit_Permissions_TitleInputs */

const vi_api_keys_edit_permissions_title = /** @type {(inputs: Api_Keys_Edit_Permissions_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sửa quyền: ${i?.name}`)
};

/**

* @param {Api_Keys_Edit_Permissions_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_edit_permissions_title = /** @type {((inputs: Api_Keys_Edit_Permissions_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Edit_Permissions_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_edit_permissions_title(inputs)
});